// eslint-disable-next-line @typescript-eslint/naming-convention,import/prefer-default-export
export enum VARIANT_CLASS_MAP {
  'scroll' = 'horizontal', // card to scroll horizontally on smaller devices
  'single-scroll' = 'horizontal-single', // cards to be scrolled for xs and below only, shows single card at a time
  'wrap' = '', // card to stacked on smaller devices
}
